export default __webpack_public_path__ + "static/media/magic-tiles.78844910.webp";